import React from 'react';
import MainLayOut from '../layout/MainLayOut';

const TermsCondition = () => {
  return (
    <>
      <MainLayOut>
        <div className="max-w-5xl m-auto py-10">
          
          <header className="text-center mt-5 mb-8">
            <h1 className="text-3xl font-bold">Terms and Conditions</h1>
            <h4 className="font-semibold text-lg mt-2">OVERVIEW</h4>
          </header>

          <section className="space-y-6 leading-7 text-justify text-gray-700">
            <p>
              Here are the Terms & Conditions, Privacy Policy, and Return & Refund Policy pages 
              for your website <strong>MPI Virgin Plastic</strong>, based in Siliguri, West Bengal, India. 
              These are modeled using Indian jurisdiction and relevant e-commerce regulations.
            </p>

            <h2 className="text-xl font-semibold mt-10">1. Terms & Conditions</h2>

            <section>
              <h3 className="text-lg font-semibold mt-6">MPI Virgin Plastic – Terms & Conditions</h3>
              <p><strong>Last updated:</strong> 20/10/2025</p>

              <p>
                Welcome to <strong>MPI Virgin Plastic</strong>. These Terms & Conditions (“Terms”) govern your 
                access to and use of our website and the purchase of products from our online store. 
                By using the Website or placing an order, you agree to these Terms.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">1. Definitions</h3>
              <ul className="list-disc ml-6">
                <li><strong>Company / We / Us:</strong> MPI Virgin Plastic, Siliguri, West Bengal.</li>
                <li><strong>Customer / You:</strong> Any individual or business visiting or making purchases.</li>
                <li><strong>Products:</strong> Virgin plastic materials or related items.</li>
                <li><strong>Order:</strong> A purchase request made through the Website.</li>
                <li><strong>Services:</strong> Activities related to selling and shipping Products.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">2. Eligibility</h3>
              <ul className="list-disc ml-6">
                <li>You must be at least 18 years old to place an order.</li>
                <li>You must be legally competent under the Indian Contract Act, 1872.</li>
                <li>You agree to provide accurate and complete information when placing an order.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">3. Account Registration</h3>
              <ul className="list-disc ml-6">
                <li>You may need to create an account to purchase items.</li>
                <li>You are responsible for safeguarding your credentials.</li>
                <li>Notify us immediately if you suspect unauthorized access.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">4. Product Information & Pricing</h3>
              <ul className="list-disc ml-6">
                <li>We strive to display accurate product information.</li>
                <li>Prices are in INR and include taxes unless stated otherwise.</li>
                <li>Prices may change but not for orders already confirmed.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">5. Payment</h3>
              <ul className="list-disc ml-6">
                <li>Payments can be made via integrated payment gateways.</li>
                <li>You confirm the payment method belongs to you.</li>
                <li>Payments are subject to verification.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">6. Shipping & Delivery</h3>
              <ul className="list-disc ml-6">
                <li>Products are shipped from Siliguri, West Bengal.</li>
                <li>Delivery timelines and charges are shown during checkout.</li>
                <li>Risk passes to you upon delivery.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">7. User Obligations & Prohibited Activities</h3>
              <ul className="list-disc ml-6">
                <li>No illegal or unauthorized use of the Website.</li>
                <li>No bots, scrapers, or automated tools.</li>
                <li>No interference with servers or networks.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">8. Intellectual Property</h3>
              <p>
                All content is owned or licensed by us. You may not reproduce or distribute it without permission.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">9. Order Acceptance & Cancellation</h3>
              <ul className="list-disc ml-6">
                <li>Order confirmation does not guarantee acceptance.</li>
                <li>We may cancel orders in cases like pricing errors or fraud.</li>
                <li>Refunds will be issued for canceled paid orders.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">10. Returns, Refunds & Exchanges</h3>
              <p>Handled per our official Return & Refund Policy.</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">11. Limitation of Liability</h3>
              <p>
                We are not liable for indirect or consequential damages. 
                Our total liability is limited to the amount paid for the Product.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">12. Dispute Resolution & Governing Law</h3>
              <p>These Terms are governed by Indian laws. Courts in Siliguri have exclusive jurisdiction.</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">13. Termination</h3>
              <p>
                We may suspend or terminate access for any policy breach.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">14. Disclaimer</h3>
              <p>No guarantee of absolute accuracy of Website content or Product expectations.</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">15. Changes to Terms</h3>
              <p>We may update Terms occasionally; continued use implies acceptance.</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mt-6">16. Contact Us</h3>
              <p>
                <strong>MPI Virgin Plastic</strong><br />
                Siliguri, West Bengal, India<br />
                Email: mpislg21@gmail.com<br />
                Phone: 9733228888
              </p>
            </section>

          </section>
        </div>
      </MainLayOut>
    </>
  );
};

export default TermsCondition;
